import Registered from 'Components/Guards/Registered';
import NotRemoteControl from 'Components/Guards/NotRemoteControl';
import RemoteControl from 'Components/Guards/RemoteControl';
import RemoteControlGuest from 'Components/Guards/RemoteControlGuest';

export default {
    'registered': Registered,
    'not-remote-control': NotRemoteControl,
    'remote-control': RemoteControl,
    'remote-control-guest': RemoteControlGuest,
};
